export default "/images/432135865306958a79176b7f80ad74f6.avif";